var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" けろよーん "+_vm._s(_vm.$isLogin)+" "),_c('Login',{attrs:{"tosUrl":"https://connect.uedasoft.com/docs/tos.html","privacyPolicyUrl":"https://connect.uedasoft.com/docs/privacy.html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }